import { Card } from '@components/sds/card/card';
import ChevronRightIcon from '@components/sds/icons/chevron-right';
import styles from './section-card.module.scss';

export interface SectionCardProps {
  title: string;
  onClick: () => void;
}

export const SectionCard = ({ title, onClick }: SectionCardProps) => {
  return (
    <Card onClick={onClick}>
      <div className={styles.content}>
        <span>{title}</span>

        <ChevronRightIcon className={styles.icon} />
      </div>
    </Card>
  );
};
